"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPService = void 0;
const users_1 = require("../../utils/users");
const api_1 = __importDefault(require("../api"));
class HTTPService {
    constructor() {
        this.setAuthorization = () => {
            const accessToken = (0, users_1.getAccessToken)();
            if (accessToken && accessToken.trim().length > 0) {
                api_1.default.defaults.headers.authorization = `Bearer ${accessToken}`;
            }
        };
        this.api = api_1.default;
    }
    get(url) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAuthorization();
            const { data } = yield this.api.get(url);
            return data;
        });
    }
    post(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAuthorization();
            const { data: dataResponse } = yield this.api.post(url, data);
            return dataResponse;
        });
    }
    put(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAuthorization();
            const { data: dataResponse } = yield this.api.put(url, data);
            return dataResponse;
        });
    }
    delete(url) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAuthorization();
            const { data } = yield this.api.delete(url);
            return data;
        });
    }
}
exports.HTTPService = HTTPService;
